import React, { useState, useEffect } from 'react';
import { updateHeroConfig, getHeroConfig } from '../firebase/services';
import toast from 'react-hot-toast';
import './Admin.css';

export default function ManageHero() {
  const [formData, setFormData] = useState({
    title: '',
    subtitle: '',
    buttonText: '',
    buttonLink: '',
    mediaUrl: ''
  });
  const [mediaFile, setMediaFile] = useState(null);
  const [mediaPreview, setMediaPreview] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadHeroConfig();
  }, []);

  const loadHeroConfig = async () => {
    const config = await getHeroConfig();
    if (config) {
      setFormData(config);
      if (config.mediaUrl) {
        setMediaPreview(config.mediaUrl);
      }
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setMediaFile(file);
      setMediaPreview(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await updateHeroConfig(formData, mediaFile);
      toast.success("Hero section updated successfully!");
      loadHeroConfig(); // Reload to ensure sync
    } catch (error) {
      toast.error("Error updating hero: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  const isVideo = (url) => {
    return url && (url.endsWith('.mp4') || url.endsWith('.webm') || url.includes('video'));
  };

  return (
    <div className="admin-container">
      <div className="admin-card">
        <div className="admin-header">
          <h2>Manage Hero Section</h2>
          <p>Update the main banner content and image/video</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="section-title">
            <ion-icon name="text-outline"></ion-icon> Hero Content
          </div>

          <div className="input-group">
            <label>Hero Title</label>
            <input 
              className="custom-input" 
              name="title" 
              value={formData.title} 
              onChange={handleChange} 
              placeholder="e.g. Highest Quality Pet Food"
            />
          </div>

          <div className="input-group">
            <label>Hero Subtitle</label>
            <input 
              className="custom-input" 
              name="subtitle" 
              value={formData.subtitle} 
              onChange={handleChange} 
              placeholder="e.g. Sale up to 40% off today"
            />
          </div>

          <div className="form-grid">
            <div className="input-group">
              <label>Button Text</label>
              <input 
                className="custom-input" 
                name="buttonText" 
                value={formData.buttonText} 
                onChange={handleChange} 
                placeholder="e.g. Shop Now"
              />
            </div>
            <div className="input-group">
              <label>Button Link</label>
              <input 
                className="custom-input" 
                name="buttonLink" 
                value={formData.buttonLink} 
                onChange={handleChange} 
                placeholder="e.g. /shop"
              />
            </div>
          </div>

          <div className="section-title">
            <ion-icon name="image-outline"></ion-icon> Background Media
          </div>

          <div className="input-group">
            <label htmlFor="hero-upload" className="image-upload-area">
              {mediaPreview ? (
                isVideo(mediaPreview) ? (
                  <video src={mediaPreview} controls className="image-preview" style={{maxHeight: '300px'}} />
                ) : (
                  <img src={mediaPreview} alt="Preview" className="image-preview" style={{maxHeight: '300px'}} />
                )
              ) : (
                <>
                  <div className="upload-icon">
                    <ion-icon name="cloud-upload-outline"></ion-icon>
                  </div>
                  <p>Click to upload image or video</p>
                  <span className="helper-text">Supports: JPG, PNG, MP4, WEBM</span>
                </>
              )}
            </label>
            <input 
              id="hero-upload"
              type="file" 
              accept="image/*,video/*" 
              onChange={handleFileChange} 
              style={{display: 'none'}}
            />
          </div>

          <button type="submit" className="btn-primary" disabled={loading}>
            {loading ? 'Updating...' : (
              <>
                <ion-icon name="save-outline"></ion-icon> Update Hero Section
              </>
            )}
          </button>
        </form>
      </div>
    </div>
  );
}
